<template>
  <v-card>
    <template v-if="finishedRender">
      <v-card-title
        v-show="
          hasProblem && productsTotal > 0 && $route.name !== 'commissioner'
        "
      >
        <h2 class="checkout-h2 grey--text text-xs-center">
          .
        </h2>
      </v-card-title>
      <login-section v-if="!secondPaymentStep"></login-section>
      <div
        v-show="
          showBuyerData ||
            $route.name === 'totem' ||
            $route.name === 'commissioner'
        "
      >
        <v-card-title>
          <h2 class="checkout-h2">Dados do Comprador</h2>
        </v-card-title>

        <buyer-data />

        <partial-payment v-if="paymentData && paymentData.split_payment" />

        <purchase-politics
          v-if="eventDetails && eventDetails.politica_compra"
        />

        <opt-in
          v-if="eventDetails && eventDetails.checkout_opt_in"
          :text="eventDetails ? eventDetails.checkout_opt_in_texto : ''"
          :value="eventDetails ? eventDetails.checkout_opt_in : ''"
        />
      </div>
      <v-card-title
        v-show="
          !hasProblem &&
            productsQuantity > 0 &&
            productsTotal !== 0 &&
            !secondPaymentStep
        "
      >
        <h2 class="checkout-h2">Como você deseja pagar?</h2>
      </v-card-title>
      <payment-options />
    </template>
  </v-card>
</template>

<script>
import PaymentOptions from './PaymentOptions';
import BuyerData from './BuyerData';
import loginSection from '../Infos/loginSection';
import PartialPayment from './PartialPayment.vue';
import PurchasePolitics from './PurchasePolitics.vue';
import { mapGetters } from 'vuex';
import OptIn from './OptIn.vue';

export default {
  components: {
    PaymentOptions,
    BuyerData,
    loginSection,
    PartialPayment,
    PurchasePolitics,
    OptIn,
  },
  data: () => ({
    finishedRender: false,
  }),
  async created() {
    await this.fetchPaymentOptions();
  },
  methods: {
    async fetchPaymentOptions() {
      const { eventID, pdv } = this.$store.getters;
      await this.$store.dispatch('fetchPaymentOptions', {
        eventID,
        pdv: pdv,
        total: this.productsTotal,
        commissioner: this.$route.name === 'commissioner',
        coupon: this.cupomCode,
      });
      this.finishedRender = true;
    },
  },
  computed: {
    ...mapGetters(['eventDetails', 'cupomCode']),
    showBuyerData() {
      if (!this.orderTickets) {
        this.$store.commit(
          'SET_ORDER_TICKETS',
          JSON.parse(localStorage.getItem('ORDER_TICKETS'))
        );
        this.$store.dispatch('setPurchaseStarted', false);
      }
      const onlyOneTicket = this.orderTickets.length === 1;
      const ticket =
        this.orderTickets[0] && this.orderTickets[0].dados_extras
          ? this.orderTickets[0].dados_extras
          : [];

      const nome = ticket.find(n => n.tipo === 'nome');
      const email = ticket.find(n => n.tipo === 'email');
      const namedTicket =
        !!nome && !!email && !!nome.valor.length && !!email.valor.length;
      return (
        !(this.productsTotal === 0 && onlyOneTicket && namedTicket) &&
        ((!this.secondPaymentStep &&
          this.signSteps &&
          this.signSteps.step > 0) ||
          (!this.secondPaymentStep && this.signSteps && this.signSteps.logged))
      );
    },
    eventID() {
      return this.$store.getters.eventID;
    },
    signSteps() {
      return this.$store.getters.signSteps;
    },
    paymentData() {
      return this.$store.getters.paymentData;
    },
    cartProducts() {
      return this.$store.getters.cartProducts;
    },
    hasProblem() {
      return (
        !this.paymentData ||
        (!this.paymentData.pix &&
          !this.paymentData.billet &&
          !this.paymentData.credit_card &&
          !this.paymentData.ame_digital &&
          !this.paymentData.paypal &&
          !this.paymentData.paypal_plus)
      );
    },
    productsQuantity() {
      let total = 0;
      if (this.hasProductsCart) {
        this.cartProducts.forEach(p => {
          p.forEach(v => {
            total += v.quantidade;
          });
        });
      }
      return total;
    },
    hasProductsCart() {
      let total = 0;
      this.cartProducts.forEach(p => {
        total += p.length;
      });
      return total;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total;
    },
    ameIsSelected() {
      return this.$store.getters.ameIsSelected;
    },
    pixIsSelected() {
      return this.$store.getters.pixIsSelected;
    },
    secondPaymentStep() {
      return this.$store.getters.secondPaymentStep;
    },
    orderTickets() {
      return this.$store.getters.orderTickets;
    },
  },
};
</script>
